
import { computed, defineComponent, onMounted, ref } from 'vue';
import NewsItem from 'PortalDir/modules/News/components/Item.vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { useAppStore } from 'stores/app';
import NewsSkeletonItem from 'PortalDir/modules/Main/components/News/SkeletonItem.vue';
import { useLoadingSsr } from 'PortalDir/common/composables/useLoadingSsr';

export default defineComponent({
  name: 'NewsList',
  components: { NewsSkeletonItem, NewsItem },

  setup() {
    const appStore = useAppStore();
    const newsList = computed(() => {
      return appStore.newsList;
    });

    const { isLoading } = useLoadingSsr();

    const newsRouteName: string = 'news';
    const { isMobile } = useDeviceSize();
    const slide = ref(0);

    onMounted(async () => {
      isLoading.value = false;
    });

    return { newsRouteName, newsList, slide, isMobile, isLoading };
  },
});
